export const hasNavigator = (): boolean | Navigator =>
  typeof window !== `undefined` && navigator;

export const isMobile = {
  Android(): boolean {
    return hasNavigator() && /Android/i.test(navigator.userAgent);
  },
  BlackBerry(): boolean {
    return hasNavigator() && /BlackBerry/i.test(navigator.userAgent);
  },
  iOSPhone(): boolean {
    return (
      hasNavigator() &&
      /iPhone|iPod/i.test(navigator.userAgent) &&
      !(window as any).MSStream
    );
  },
  iOSTablet(): boolean | undefined {
    if (hasNavigator()) {
      return (
        (/iPad/i.test(navigator.userAgent) && !(window as any).MSStream) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0)
      );
    }
  },
  iOSDevice(): boolean | undefined {
    if (hasNavigator()) {
      return (
        (/iPad|iPhone|iPod/i.test(navigator.userAgent) &&
          !(window as any).MSStream) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0)
      );
    }
  },
  Opera(): boolean {
    return hasNavigator() && /Opera Mini/i.test(navigator.userAgent);
  },
  Windows(): boolean {
    return hasNavigator() && /IEMobile/i.test(navigator.userAgent);
  },
  Chrome(): boolean | undefined | null {
    if (hasNavigator()) {
      return (
        (/Chrome/.test(navigator.userAgent) &&
          /Google Inc/.test(navigator.vendor)) ||
        /CriOS/i.test(navigator.userAgent)
      );
    }
  },
  notTablet(): boolean {
    return (
      hasNavigator() &&
      (isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOSPhone() ||
        isMobile.Opera() ||
        isMobile.Windows())
    );
  },
  any(): boolean {
    return (
      hasNavigator() &&
      (isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOSPhone() ||
        isMobile.iOSTablet() ||
        isMobile.Opera() ||
        isMobile.Windows())
    );
  },
};
